// What the server says about the design: errors block submitting (missing
// table, total, invoice number, sender), warnings flag things that may look
// wrong (cut off, off the page, hard-to-read colours). Clicking an item
// selects what it is about. Announced politely to screen readers.

import React, { useState } from "react";
import FeatherIcon from "feather-icons-react";

export default function ChecksPanel({ issues, onPick }) {
  const [open, setOpen] = useState(true);
  const errors = issues.filter((i) => i.level === "error");
  const warnings = issues.filter((i) => i.level === "warning");
  return (
    <section className={`td-checks${errors.length ? " has-errors" : ""}`} aria-label="Checks">
      <button type="button" className="td-checks__head" aria-expanded={open} onClick={() => setOpen((o) => !o)}>
        <FeatherIcon icon={errors.length ? "x-circle" : warnings.length ? "alert-triangle" : "check-circle"} size={15} />
        <span>
          {errors.length
            ? `${errors.length} to fix before submitting`
            : warnings.length
              ? `Ready — ${warnings.length} warning${warnings.length === 1 ? "" : "s"}`
              : "Ready to submit"}
        </span>
        <FeatherIcon icon={open ? "chevron-down" : "chevron-up"} size={14} />
      </button>
      <div aria-live="polite">
        {open && issues.length > 0 && (
          <ul className="td-checks__list">
            {[...errors, ...warnings].map((i, k) => (
              <li key={`${i.code}-${k}`}>
                <button
                  type="button"
                  className={`td-check-item td-check-item--${i.level}`}
                  onClick={() => onPick(i)}
                  disabled={!i.elementId && !i.bandId}
                >
                  <FeatherIcon icon={i.level === "error" ? "x-circle" : "alert-triangle"} size={13} />
                  <span>{i.message}</span>
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
}
